import script from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=641f1670&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641f1670"]])

export default __exports__